import { NavLink, NavbarCollapse } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/logo.png';
import '../assets/css/menu.css'
import { Outlet, Link } from 'react-router-dom';


function Menu() {
  return (
    <>
      <Navbar style={{padding: '1rem'}} className='navbar' collapseOnSelect expand='lg' bg="secondary"  data-bs-theme="dark">
      <NavLink as={Link} to={'/'}><img className='img-menu'src={logo}/></NavLink>
      <Navbar.Toggle aria-controls='responsive-navbar-nav'/>
          <Navbar.Collapse className='m-auto'>
            <Nav  className='ms-auto' >
              <Nav.Link as={Link} className='enlaces-menu' to='/'>Inicio</Nav.Link>
              <Nav.Link as={Link} className='enlaces-menu' to='/trabajos'>Nuestros Servicios</Nav.Link>
              <Nav.Link as={Link} className='enlaces-menu' to="/contacto">Contacto</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          
        
      </Navbar>
    </>
  );
}

export default Menu;